module.exports = __webpack_public_path__ + "static/media/back.2c3632a6.svg";